import Autocomplete from './Autocomplete';
import ControlledComponent from '../../../utils/ControlledComponent';

export const ControlledAutocomplete = ControlledComponent(Autocomplete);
export default Autocomplete;
